import React, { useState, useEffect } from 'react';
import ReactGA from "react-ga4";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Prüfen, ob der Spieler schon eine Wahl getroffen hat
    const consent = localStorage.getItem("unlocked_cookie_consent");
    
    if (!consent) {
      // Wenn nicht, Banner anzeigen
      setIsVisible(true);
    } else if (consent === "accepted") {
      // Wenn er früher schon auf "Ja" geklickt hat, Analytics still im Hintergrund starten
      // WICHTIG: Ersetze die G-ID mit deiner echten!
      ReactGA.initialize("G-CTY08X2ZDW");
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("unlocked_cookie_consent", "accepted");
    ReactGA.initialize("G-CTY08X2ZDW"); // Analytics ab jetzt starten
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("unlocked_cookie_consent", "declined");
    // Analytics wird NICHT gestartet
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: "fixed", bottom: "30px", left: "50%", transform: "translateX(-50%)",
      backgroundColor: "rgba(20, 20, 20, 0.85)", border: "2px solid gold",
      borderRadius: "15px", padding: "20px 30px", zIndex: 10000,
      backdropFilter: "blur(10px)", boxShadow: "0 10px 30px rgba(0,0,0,0.8)",
      display: "flex", flexDirection: "column", alignItems: "center", 
      width: "90%", maxWidth: "600px", color: "white", textAlign: "center"
    }}>
      <h3 style={{ color: "gold", margin: "0 0 10px 0", fontSize: "1.3em" }}>🍪 Cookies?</h3>
      <p style={{ fontSize: "0.95em", color: "#ccc", margin: "0 0 20px 0", lineHeight: "1.4" }}>
        Wir nutzen Google Analytics, um anonym zu sehen, ob unser Spiel gespielt wird. 
        Erlaubst du uns, diese Daten zu erfassen? (Das Spiel funktioniert natürlich auch ohne Zustimmung!)
      </p>
      <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", justifyContent: "center" }}>
        <button 
          onClick={handleAccept} 
          style={{ padding: "10px 20px", backgroundColor: "gold", color: "black", fontWeight: "bold", border: "none", borderRadius: "8px", cursor: "pointer", transition: "transform 0.2s" }}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          Yes! ✅
        </button>
        <button 
          onClick={handleDecline} 
          style={{ padding: "10px 20px", backgroundColor: "#333", color: "white", border: "1px solid #777", borderRadius: "8px", cursor: "pointer", transition: "transform 0.2s" }}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          No ❌
        </button>
      </div>
    </div>
  );
}